<template>
    <div class="service--overnight" v-if="service.length !== 0">

        <b-row v-if="overnight_service.details.hotels.length == 0">
            <b-col cols="10" offset="1" class="d-flex align-items-center">
                <font-awesome-icon icon="plus" @click="add_hotel_to_overnight()"/>
                <small><i>Aggiungi un hotel</i></small>
            </b-col>
        </b-row>

        <div v-for="( hotel ) in overnight_service.details.hotels" v-bind:key="'hotel_'+hotel.hotel_index">
            <div class="hotel--wrapper">
                <b-row>
                    <b-col cols="10" offset="1">
                        <div class="service--overnight--hotels">
                            <hotel
                                :hotel="hotel"
                                :hotel_index="hotel.hotel_index"
                                :service_index="service.service_index"
                                v-on:removed="/*remove_hotel_from_service(hotel.hotel_index)*/"
                                v-on:updated="update_hotel_in_service"
                            />
                        </div>
                    </b-col>
                    <b-col cols="1" class="text-left">
                        <font-awesome-icon icon="times" @click="remove_hotel_from_service(hotel.hotel_index)"/>
                        <font-awesome-icon icon="plus" @click="add_hotel_to_overnight()"/>
                    </b-col>
                </b-row>
            </div>
        </div>
    </div>
</template>

<script>
import { new_overnight_hotel } from '@/quote'
import Hotel from '@/components/blocks/overnight/hotel'
export default {
    name: 'overnight',
    components: {
        'hotel': Hotel
    },
    props: {
        service: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {     
            overnight_service: this.service,
        }
    },
    created()
    {
    },
    mounted() {
    },
    methods:{
        update_service()
        {
            this.$store.commit('set_service', {
                service: this.overnight_service
            })
        },
        add_hotel_to_overnight()
        {
            let index = 0
            this.overnight_service.details.hotels.forEach(hotel => {
                if(hotel.hotel_index >= index) index = hotel.hotel_index + 1
            })    
            this.overnight_service.details.hotels.push(new_overnight_hotel(index))
            this.update_service()
        },
        update_hotel_in_service(payload)
        {
            this.overnight_service.details.hotels[payload.hotel_index] = payload.hotel
            this.update_service()            
        },
        remove_hotel_from_service(hotel_index)
        {
            this.overnight_service.details.hotels = this.overnight_service.details.hotels.filter(function(hotel){
                return hotel.hotel_index !== hotel_index
            })
            this.update_service()
        }
    },
    computed: {
    }
}
</script>

<style lang="scss">
    .service--overnight
    {
        //margin-top:$grid-gutter-width/2;
        .service--icon
        {
            margin:0;
            height:100%;
            display:flex;
            align-items: center;
            justify-content: flex-start;
        }
        &--hotels
        {
            &:not(:last-child)
            {
                margin-bottom:$grid-gutter-width/2;
            }
        }
        .hotel--wrapper
        {
            .service--overnight--hotels
            {
                @include subpanel;
            }
            &:not(:last-child)
            {
                margin-bottom:$grid-gutter-width/2;
            }
        }
    }
</style>